import React from 'react';
import { Shield, AlertTriangle } from 'lucide-react';

const TermsAndConditions = () => {
  return (
    <div className="flex-grow bg-gray-50 py-16">
      <div className="max-w-7xl mx-auto px-4">
        <div className="bg-white rounded-lg shadow-lg p-8">
          <div className="max-w-3xl mx-auto">
            <h1 className="text-4xl font-bold text-center mb-8">Terms and Conditions</h1>
            
            <div className="bg-red-50 border-l-4 border-red-500 p-6 mb-8">
              <div className="flex">
                <AlertTriangle className="h-6 w-6 text-red-500 mr-3" />
                <p className="text-red-700 font-semibold">
                  CRITICAL NOTICE: United eLoans is STRICTLY a loan matching service. We DO NOT provide loans, make lending decisions, or guarantee approvals. By using our service, you accept these terms in full.
                </p>
              </div>
            </div>

            <section className="mb-8">
              <h2 className="text-2xl font-bold mb-4">Terms of Use</h2>
              <div className="bg-gray-50 p-6 rounded-lg">
                <p className="text-gray-700">
                 United eLoans (“we” or “our”) owns and operates the website located at unitedeloan.com, (the “Site”). unitedeloan provides and maintains this site for your information, conditioned on your acceptance, without modification, of the terms, conditions and notices contained in this Terms of Use. By accessing and using the site, you accept and agree, without limitation, to the following:
                </p>
              </div>
              <div className="bg-gray-50 p-6 rounded-lg">
                <p className="text-gray-700">
                PRODUCTS AND SERVICES:
                </p>
<p className="text-gray-700">
                We are not in itself a lender. All specific loan products will be offered to you directly from the lender and therefore take no responsibility for any credit decisions that are made by the lender, about you. There are no specific loan products offered on this site.
                </p>
                
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold mb-4">E-SIGN CONSENT</h2>
              <div className="bg-gray-50 p-6 rounded-lg">
                <p className="text-gray-700">
                  You agree that by clicking “Get Started” (or any similar button you use to submit a request to be connect with a lender) it acts as your electronic signature. You grant further consent that we and any lender we forward your request to have the ability to communicate with you electronically and we may provide you electronically with any required disclosures, including without any limitation notices of adverse action a lender is required to send you. Meanwhile, you also confirm you have the ability to get access to documents electronically, including having the ability to view and save PDF files.
                </p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold mb-4">LOAN INQUIRY POLICY</h2>
              <div className="bg-gray-50 p-6 rounded-lg">
                <p className="text-gray-700">
                  We reserve the right to reject an inquiry from you at any time for any reason that is not prohibited by law. We may require verification or additional information before a loan request from you is accepted. After submitting your information via a form on our site, you will then be connected with a lender to be further considered based on the policies and procedures of the lender. This does not mean that your loan has been approved. Approval of loans is solely the decision of the lender. We take no responsibility for taking, approving or denying any loan request made by you. When you submit your information, you then agree if we are unable to find a lender that offers the type of loan you requested initially, we will then search our lender network to ascertain whether we can find alternative lenders with different loan products that may help you.
                </p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold mb-4">CREDIT REFERENCES/CREDIT CHECKS</h2>
              <div className="bg-gray-50 p-6 rounded-lg">
                <p className="text-gray-700">
                  Participating lenders in our network may then verify your social security number, the number of your driver’s license or any other official federal or state identification, as well as review your credit history through national databases which may include Transunion, Equifax, Experian and other credit check agencies. When you submit your information to us, you consent to allowing lenders to perform any type of underwriting they may require to evaluate your ability to repay any offered loan, including credit checks, and employment verification.
                </p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold mb-4">RESTRICTIONS</h2>
              <div className="bg-gray-50 p-6 rounded-lg">
                <p className="text-gray-700">
                  To submit a loan request you must be 18 years old or older and a legal resident of the United States. You also agree not to use this site for any inappropriate or illegal activities.
                </p>
              </div>
            </section>

             <section className="mb-8">
              <h2 className="text-2xl font-bold mb-4">COMPLIANCE WITH LAWS</h2>
              <div className="bg-gray-50 p-6 rounded-lg">
                <p className="text-gray-700">
                  You agree to abide by all applicable federal or state laws, statutes, regulations and ordinances regarding your use of this site and in your acceptance of, or purchase of products or services via any of this site’s third-party vendors. We may, at our sole discretion, report perceived or actual violations of law to authorities. If any potential or suspected violation of these Terms of Use or of our Privacy Policy come to our attention, we may (although not obligated to) launch an investigation to ascertain the nature and extent of the potential or suspected violation and then the appropriate enforcement action may be taken. During such investigations, we reserve the right to suspend services to any customer under investigation and may remove data from our servers as a way to prevent or minimize further violations from occurring. Should you be the subject of any such investigation, you agree to cooperate fully. You acknowledge you could be subject to criminal or civil penalties for violating the Terms of Use or Privacy Policy.
                </p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold mb-4">INTELLECTUAL PROPERTY</h2>
              <div className="bg-gray-50 p-6 rounded-lg">
                <p className="text-gray-700">
                  All trademarks, characters, titles, graphics, trade names, designs and other property, including all text, images and software, which appear on this site are the intellectual property of unitedeloan, its licensees, and other third parties who may have authorized use of such properties.

You have the permission to view and make copies for your own records of documents, images, pages or other material or content on this site for the sole purpose of making a loan request. We reserve all other rights to this site and its contents. You are prohibited from distributing, displaying, transmitting or disseminating any documents, pages, images, materials or content without our prior consent in writing. Nothing this site contains should be construed as conferring any rights or licenses to any trademark, copyright or any other intellectual property right.
                </p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold mb-4">LIMITATION OF LIABILITY AND DISCLAIMER OF WARRANTIES</h2>
              <div className="bg-gray-50 p-6 rounded-lg">
                <p className="text-gray-700">
                 We use all commercially reasonable efforts to ensure the information on this site is accurate, but that accuracy is not guaranteed. We offer no representations regarding your use of this site or the results you may or may not obtain through your use thereof.
                </p>
              </div>

              <div className="bg-gray-50 p-6 rounded-lg">
                <p className="text-gray-700">
                 NEITHER WE NOR ANY OTHER PARTY INVOLVED IN CREATING, DELIVERING OR PRODUCING THIS SITE SHALL BE DEEMED LIABLE FOR ANY DIRECT, INDIRECT, CONSEQUENTIAL, INCIDENTAL, SPECIAL OR PUNITIVE DAMAGES THAT ARISE OUT OF YOUR ACCESS TO, OR USE OF, THIS SITE. EVERYTHING PROVIDED ON THIS SITE IS “AS IS” AND WITHOUT CARRYING A WARRANTY OF ANY DESCRIPTION, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO, ANY FITNESS FOR A PARTICULAR PURPOSE, WARRANTY OF MERCHANTABILITY OR NON-INFRINGEMENT THAT MAY BE IMPLIED. THESE LIMITATIONS AND EXCLUSIONS ARE APPLIED TO THE FULLEST EXTENT PERMITTED BY LAW.
                </p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold mb-4">THIRD PARTY CONTENT</h2>
              <div className="bg-gray-50 p-6 rounded-lg">
                <p className="text-gray-700">
                  This site may contain links to third party websites. We are not responsible for the privacy policies or content of third party websites, and the existence of such links should not be considered to be a recommendation or endorsement of those websites, or the products or services offered or any third parties that are associated with those websites.
                </p>
              </div>
            </section>

             <section className="mb-8">
              <h2 className="text-2xl font-bold mb-4">PRIVACY</h2>
              <div className="bg-gray-50 p-6 rounded-lg">
                <p className="text-gray-700">
                 Our Privacy Policy, incorporated herein by reference, is applicable to any data supplied via this Site. The Privacy Policy clarifies your rights and our responsibilities in regards to your personal information. We undertake not to use your information in any way that is inconsistent with the limitations and purposes provided in the Privacy Policy. We reserve the right, at its sole discretion, to modify the Privacy Policy at any time without prior notice to you. Modifications made to the Privacy Policy are effective from when posted and your continued use of this site signifies you accept such modifications.
                </p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold mb-4">SECURITY</h2>
              <div className="bg-gray-50 p-6 rounded-lg">
                <p className="text-gray-700">
                 We guard your personal information using industry-recognized technology. Although We take all commercially reasonable measures to secure your personal information when submitted through this site, we cannot offer a guarantee your information will not be decrypted or intercepted by others. So long as we use all commercially reasonable security measures, it accepts no responsibility for such decryption or interception except as required by law.
                </p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold mb-4">SITE USE</h2>
              <div className="bg-gray-50 p-6 rounded-lg">
                <p className="text-gray-700">
                 We do not charge any fees for you to use this Site or our marketplace service. We are not acting as an agent for (a) you, (b) any lender or (c) any vendor or supplier used to evaluate your loan inquiry or any other use of this site. We may receive compensation for its services from lenders and other third parties.
                </p>
              </div>
            </section>

              <section className="mb-8">
              <h2 className="text-2xl font-bold mb-4">LAW AND VENUE</h2>
              <div className="bg-gray-50 p-6 rounded-lg">
                <p className="text-gray-700">
                 By using this site or by engaging with unitedeloan in any way, you consent to abide by the laws and jurisdiction of Nevis. Both these Terms of Use and the Privacy Policy will be governed by and construed in accordance with Nevis laws, without regard to conflict of law provisions. Any legal action brought against unitedeloan (which must come via binding arbitration as set forth below) will be governed by the laws of Nevis and you agree that the sole venue and jurisdiction for disputes resolution will be in Charlestown, Nevis.
                </p>
              </div>
            </section>

              <section className="mb-8">
              <h2 className="text-2xl font-bold mb-4">BINDING ARBITRATION</h2>
              <div className="bg-gray-50 p-6 rounded-lg">
                <p className="text-gray-700">
                 Should any dispute arise regarding the interpretation of any provision or term contained in these Terms of Use or with regard to any of your dealings with unitedeloan or dealings with any lender you thus borrow from as a result of unitedeloan’s service, all issues shall be decided by binding arbitration. Arbitration proceedings shall be conducted under all the applicable rules of the American Arbitration Association or JAMS in Charlestown, Nevis. The decision of the arbitrator shall be binding and final on both parties. The prevailing party then shall be entitled to recover the costs of arbitration, travel expenses, expert testimony expenses, travel expenses of experts, and all other expenses reasonably incurred in bringing about or defending an arbitration claim, from the other party unless it is otherwise prohibited by law.
                </p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold mb-4">MODIFICATION</h2>
              <div className="bg-gray-50 p-6 rounded-lg">
                <p className="text-gray-700">
                We reserve the right to modify these Terms of Use occasionally and without prior notice to you. Your use of this site after such modification constitutes your agreement to and acceptance of any new or amended terms.
                </p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold mb-4">INDEMNIFICATION</h2>
              <div className="bg-gray-50 p-6 rounded-lg">
                <p className="text-gray-700">
                By using this site, you agree to defend, indemnify and hold harmless unitedeloan, any of its subsidiaries, affiliates, agents, officers and other partners and employees, from any liability, loss, claim or demand, including reasonable attorneys’ fees, made by any third party arising out of or due to your use or attempted use of the site.
                </p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold mb-4">VIOLATION OF THE TERMS OF USE</h2>
              <div className="bg-gray-50 p-6 rounded-lg">
                <p className="text-gray-700">
                By using this site, you agree to defend, indemnify and hold harmless unitedeloan, any of its subsidiaries, affiliates, agents, officers and other partners and employees, from any liability, loss, claim or demand, including reasonable attorneys’ fees, made by any third party arising out of or due to your use or attempted use of the site.
                </p>
              </div>
            </section>

             <section className="mb-8">
              <h2 className="text-2xl font-bold mb-4">CLASS ACTION WAIVER</h2>
              <div className="bg-gray-50 p-6 rounded-lg">
                <p className="text-gray-700">
               ANY PROCEEDINGS TO RESOLVE, ARBITRATE OR LITIGATE ANY DISPUTE IN ANY FORUM WILL BE CONDUCTED SOLELY ON A CASE-BY-CASE BASIS. NEITHER YOU NOR US WILL SEEK TO HAVE A DISPUTE HEARD AS A CLASS ACTION, OR A PRIVATE ATTORNEY GENERAL ACTION, OR IN ANY OTHER PROCEEDING IN WHICH EITHER PARTY WILL ACT OR PROPOSES TO ACT IN A REPRESENTATIVE CAPACITY. NO PROCEEDING OR ARBITRATION WILL BE COMBINED WITH ANOTHER WITHOUT THE PRIOR WRITTEN CONSENT OF ALL THE PARTIES TO ALL AFFECTED PROCEEDINGS OR ARBITRATIONS. FURTHERMORE, YOU AGREE YOU WILL NOT SEEK TO HAVE ANY DISPUTE AGAINST ANY LENDER TO WHOM YOU ARE REFERRED ON TO HEARD AS A CLASS ACTION, OR A PRIVATE ATTORNEY GENERAL ACTION, OR IN ANY OTHER PROCEEDING IN WHICH EITHER PARTY WILL ACT OR PROPOSES TO ACT IN A REPRESENTATIVE CAPACITY. THIS CLASS ACTION WAIVER MAY BE LIMITED BY APPLICABLE LAW, BUT IT IS INTENDED TO BE ENFORCED TO THE FULL EXTENT PERMITTED BY LAW.

                </p>
              </div>
            </section>

             <section className="mb-8">
              <h2 className="text-2xl font-bold mb-4">MISCELLANEOUS</h2>
              <div className="bg-gray-50 p-6 rounded-lg">
                <p className="text-gray-700">
                By using this site, you agree to defend, indemnify and hold harmless unitedeloan, any of its subsidiaries, affiliates, agents, officers and other partners and employees, from any liability, loss, claim or demand, including reasonable attorneys’ fees, made by any third party arising out of or due to your use or attempted use of the site.
                </p>
              </div>
            </section>

            
                        

            <section className="mb-8">
              <h2 className="text-2xl font-bold mb-4">CONTACT INFORMATION:</h2>
              <div className="bg-gray-50 p-6 rounded-lg">
                <p className="text-gray-700 mb-4">
                 Email Address: contact@unitedeloan.com
                </p>
                
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold mb-4">Referring short code</h2>
              <div className="bg-gray-50 p-6 rounded-lg">
                <p className="text-gray-700">
                You agree to provide “prior express written consent”, under the definition outlined in the Telephone Consumer Protection Act (“TCPA”), to receive telephone calls, including artificial voice calls, pre-recorded messages and/or calls delivered via automated technology, and text and SMS messages to the telephone number(s) that you provided to us, from unitedeloan, and our network partners, including lenders and/or other network providers. You are not required to provide this consent to utilize the services offered on unitedeloan.com. Your consent simply allows us to contact you via these means. If you provide consent, unitedeloan and our affiliates or Marketing Partners may send you SMS messages from their short codes or long codes. Recurring messages are maximum 9 messages per week. Message and data rates may apply. Text STOP to opt-out from future messages. The mobile carriers are not liable for delayed or undelivered messages.
                </p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold mb-4">Modification</h2>
              <div className="bg-gray-50 p-6 rounded-lg">
                <p className="text-gray-700">
                unitedeloan.com reserves the right to modify these Terms of Use from time to time. Your use of the Site after such a modification will constitute your acceptance of, and your agreement to, any new or amended Terms of Use.
                </p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold mb-4">Indemnification</h2>
              <div className="bg-gray-50 p-6 rounded-lg">
                <p className="text-gray-700">
                By using the Site, you agree to indemnify and hold unitedeloan, its subsidiaries, affiliates, officers, agents and other partners and employees, harmless from any loss, liability, claim or demand, including reasonable attorneys’ fees, made by any third party due to or arising out of your use or attempted use of the Site, including providing a link to another site or uploading any content to the Site.
                </p>
              </div>
            </section>

             <section className="mb-8">
              <h2 className="text-2xl font-bold mb-4">Miscellaneous</h2>
              <div className="bg-gray-50 p-6 rounded-lg">
                <p className="text-gray-700">
                All rights not expressly granted are reserved to unitedeloan. The headings used in these Terms of Use are intended for convenience only, and shall not affect the construction and interpretation hereof or thereof. A party’s failure to insist upon or enforce strict performance of any provision of the Terms of Use shall not be construed as a waiver of such or any future provision or right. If any provision of these Terms of Use is held to be invalid or unenforceable, such determination shall not affect such provision in any other respect or any other provision of these Terms of Use, which shall remain in full force and effect. These Terms of Use and the Privacy Policy constitute the entire agreement and understanding between the parties with respect to the subject matter contained herein and therein and supersedes and replaces any and all prior written or oral agreements related to the subject matter hereof.
                </p>
              </div>
            </section>
            

            <section className="mb-8">
              <h2 className="text-2xl font-bold mb-4">User Acknowledgments</h2>
              <div className="bg-orange-50 p-6 rounded-lg">
                <p className="text-gray-700 mb-4">
                  By using our service, you explicitly acknowledge and agree that:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700">
                  <li>You are responsible for verifying lender legitimacy</li>
                  <li>United eLoans is not liable for any financial losses</li>
                  <li>Your information will be shared with multiple lenders</li>
                  <li>Lenders may contact you directly</li>
                  <li>You must verify all loan terms independently</li>
                </ul>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold mb-4">Liability Waiver</h2>
              <div className="bg-red-50 p-6 rounded-lg">
                <p className="text-red-700 font-semibold mb-4">
                  United eLoans SHALL NOT be held liable for:
                </p>
                <ul className="list-disc list-inside space-y-2 text-red-700">
                  <li>Any financial losses or damages</li>
                  <li>Fraudulent activities by third parties</li>
                  <li>Lender practices or decisions</li>
                  <li>Loan terms or agreements</li>
                  <li>Data breaches by third-party lenders</li>
                </ul>
              </div>
            </section>

            

            <div className="bg-gray-100 p-6 rounded-lg">
              <h3 className="text-xl font-bold mb-4 text-red-600">Legal Disclaimer</h3>
              <p className="text-gray-700">
                These terms constitute a legally binding agreement. By using United eLoans' services, you waive all rights to legal action against United eLoans for any damages, losses, or disputes arising from:
              </p>
              <ul className="list-disc list-inside mt-4 space-y-2 text-gray-700">
                <li>Lender interactions or decisions</li>
                <li>Financial losses or damages</li>
                <li>Fraudulent activities</li>
                <li>Data breaches or misuse</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;